import React from "react";

import DisplayTypeSet from "../../types/system/DisplayTypeSet";
import { DisplaySettingSection } from "../../types/system/DisplayType";
import Panel from "../panels/Panel";
import { Side } from "../../types/system/Layout";
import DisplaySettingMainSection from "./DisplaySettingMainSection";

import "./DisplaySettings.scss";

interface DisplaySettingMainProps {
    routeDisplay: string[];
    workingDisplay: DisplayTypeSet;
}

class DisplaySettingMain extends React.Component<DisplaySettingMainProps> {
    render() {
        return (
            <>
                {!this.props.workingDisplay.types && (
                    <div className="buffer">
                        Display settings cannot be changed for this screen
                    </div>
                )}

                {this.props.workingDisplay.types
                    .filter(
                        item =>
                            item.section === DisplaySettingSection.Main &&
                            this.props.routeDisplay.includes(item.type),
                    )
                    .map((setting, index) => (
                        <DisplaySettingMainSection
                            key={index}
                            setting={setting}
                        />
                    ))}
            </>
        );
    }
}

export default DisplaySettingMain;
